export default [
    "24 24",
    '<path d="M9 9L5.63604 12.364C4.07394 13.9261 4.07394 16.4587 5.63604 18.0208C7.19815 19.5829 9.73084 19.5829 11.2929 18.0208L12 17.3137M15 15L18.364 11.636C19.9261 10.0739 19.9261 7.54132 18.364 5.97922C16.8019 4.41711 14.2692 4.41711 12.7071 5.97922L12 6.68633M8 21L6 19M18 5L16 3" fill="none" class="stroke-over" stroke="var(--ci-primary-color, currentColor)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
]
